import { comparisonTitle, comparisonSubtitle, comparisonData } from "@/mocks/content";

export default function ComparisonSection() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
            {comparisonTitle}
          </h2>
          <p className="text-foreground-600 text-base md:text-lg">
            {comparisonSubtitle}
          </p>
        </div>

        <div className="overflow-x-auto rounded-2xl border border-background-200/70">
          <table className="w-full text-left">
            <thead>
              <tr className="bg-background-100">
                <th className="px-6 py-4 text-sm font-semibold text-foreground-900 whitespace-nowrap">Feature</th>
                <th className="px-6 py-4 text-sm font-semibold text-foreground-900 whitespace-nowrap text-center">
                  <span className="inline-flex items-center gap-1.5">
                    Our Spreadsheet
                    <i className="ri-star-fill text-accent-500 w-3.5 h-3.5 flex items-center justify-center"></i>
                  </span>
                </th>
                <th className="px-6 py-4 text-sm font-semibold text-foreground-500 whitespace-nowrap text-center">Manual Search</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr key={row.feature} className={`${idx % 2 === 0 ? "bg-background-50" : "bg-background-100/50"} border-t border-background-200/50`}>
                  <td className="px-6 py-4 text-sm text-foreground-800 font-medium whitespace-nowrap">{row.feature}</td>
                  <td className="px-6 py-4 text-center">
                    {row.ours === true ? (
                      <i className="ri-check-line text-accent-500 text-lg w-5 h-5 flex items-center justify-center mx-auto"></i>
                    ) : (
                      <span className="text-sm text-foreground-700">{row.ours}</span>
                    )}
                  </td>
                  <td className="px-6 py-4 text-center">
                    {row.manual === true ? (
                      <i className="ri-check-line text-foreground-400 text-lg w-5 h-5 flex items-center justify-center mx-auto"></i>
                    ) : row.manual === false ? (
                      <i className="ri-close-line text-foreground-400 text-lg w-5 h-5 flex items-center justify-center mx-auto"></i>
                    ) : (
                      <span className="text-sm text-foreground-500">{row.manual}</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}